import { useState, useEffect } from 'react';

type WindowSize = {
  width: Window['window']['innerWidth'] | undefined;
  height: Window['window']['innerHeight'] | undefined;
};

const useWindowResizeListener = () => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

export default useWindowResizeListener;
